export default __webpack_public_path__ + "static/media/shot-1.457e9ca5.png";